import { TableSortLabel } from '@openx/design-system/components/Table/TableSortLabel';
import type { ReactNode } from 'react';
import type { OpenXAgentTableSorting } from './utils/useSorting';

type OpenXAgentTableSortLabelProps = {
  sorting: OpenXAgentTableSorting;
  columnId: string;
  children: ReactNode;
};

export const OpenXAgentTableSortLabel = ({ sorting, columnId, children }: OpenXAgentTableSortLabelProps) => (
  <TableSortLabel
    active={sorting.orderBy === columnId}
    direction={sorting.orderBy === columnId ? sorting.direction : 'asc'}
    onClick={() => sorting.onSort(columnId)}
  >
    {children}
  </TableSortLabel>
);
